<div class="{{localService.selectedLanguageCode}}">
  <div style="max-width:1000px;" class="center">
    <div class="row">
      <div class="col-md-12">
        <div *ngIf="localService.selected.user && localService.languageContent && localService.languageContent.guide" class="freeze_height" style="float:left;"
          [ngStyle]="{'width' : (localService.selected.user && localService.isActionAllowed(1) ? 'calc(100% - 120px)' : 'calc(100% - 40px)')}">
          <ngx-select [(ngModel)]="selectedPageKey" [items]="pageKeys" [optionValueField]="'key'"
            [optionTextField]="'s_value'" placeholder="{{localService.languageContent.guide.select_page_key}}"
            (select)="onLoadGuide()">
            <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
              <div>
                {{option.data.value}}
              </div>
            </ng-template>
          </ngx-select>
        </div>
        <div *ngIf="!localService.selected.user" class="freeze_height" style="float:left;width:calc(100% - 40px);">
          <ngx-select [(ngModel)]="selectedPageKey" [items]="pageKeys" [optionValueField]="'key'"
            [optionTextField]="'s_value'" (select)="onLoadGuide()">
            <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
              <div>
                {{option.data.value}}
              </div>
            </ng-template>
          </ngx-select>
        </div>
        <div style="float: right;position: relative;"
          [ngStyle]="{'top' : (localService.selected.user != '' && localService.isActionAllowed(1) ? '-10px' : '-2px')}">
          <i class="material-icons on_language_changed icon_adjust" (click)="onLoad()">replay_circle_filled</i>
          <i class="material-icons icon_adjust"
            *ngIf="localService.selected.user != '' && localService.isActionAllowed(1)"
            (click)="onAction(1)">settings</i>
          <i class="material-icons button icon_adjust"
            *ngIf="localService.selected.user != '' && localService.isActionAllowed(1)"
            (click)="onAction(2)">file_download</i>
          <app-file-upload class="icon_adjust"
            *ngIf="localService.selected.user != '' && localService.isActionAllowed(1)"
            [fileUploadFor]="isManualDownloadUpload ? FileUploadFor.UserGuideManual : FileUploadFor.UserGuide"></app-file-upload>
        </div>
      </div>
    </div>
    <div *ngIf="localService.languageContent && localService.languageContent.guide && selectedPageKey && selectedPageKey != '0-0'" class="row">
      <div class="col-12">
        <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
          <br />
          <app-html-viewer *ngIf="content != null" [content]="content"
            [contentLanguageId]="contentLanguageId"></app-html-viewer>
          <div *ngIf="content == null || content == ''" style="text-align:center;">
            {{localService.languageContent.guide.unavailable}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div style="max-width:1000px;" class="center"
  *ngIf="!localService.selected.user && !(localService.languageContent && localService.languageContent.guide)">
  <div class="row">
    <div class="col-12">
      <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight - 20 + 'px'}">
        <app-html-viewer *ngIf="content" [content]="content" [contentLanguageId]="contentLanguageId"></app-html-viewer>
      </div>
    </div>
  </div>
</div>